import { BorderBox } from "@/components/atoms/BorderBox";
import Combobox from "@/components/custom/Combobox";
import { Input } from "@/components/ui/input";
import { useGetOrganizationCrmSystems } from "@/features/organization/hooks/utils/useGetOrganizationCrmSystems/useGetOrganizationCrmSystems";
import { SelectCrmSystemSanitizedComboboxProps } from ".";
import { useEffect, useMemo } from "react";

export function SelectCrmSystemSanitizedCombobox({ mode, showInfo = true, ...props }: Readonly<SelectCrmSystemSanitizedComboboxProps>) {
    const crmSystems = useGetOrganizationCrmSystems();
    const items = useMemo(() => crmSystems.map(system => ({
        label: system.name,
        value: system.id
    })), [crmSystems])

    useEffect(()=>{
        if(items.length === 1 && mode === 'single' && !props.selectedValue){
            props.setSelectedValue(items[0].value)
        }
    },[items, mode, props.selectedValue, props.setSelectedValue])
    return (
        <div className="flex flex-col gap-2">
            
            {(() => {
                if (items.length === 0) {
                    return (
                        <BorderBox variant='danger' size='sm'>
                            No CRM systems available for given organization
                        </BorderBox>
                    )
                }
                if (items.length === 1 && mode === 'single') {
                    return <Input disabled value={items[0].label} />
                }
                return (
                    <Combobox
                        {...props}
                        mode={mode}
                        triggerLabel={mode === 'multiple' ? 'Select CRM Systems' : 'Select CRM System'}
                        items={items}
                    />
                )
            })()}
            {showInfo && (
                <BorderBox size='sm' variant='info'>
                    These are the systems that were picked during creation of the organization. You can edit this list on Manage Organization page
                </BorderBox>
            )}
        </div>
    )
}